import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function PublicSupervisionServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1074_2148)'} = props;
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32">
			<path opacity="0.4"
			      d="M23.3734 10.3601C23.28 10.3468 23.1867 10.3468 23.0934 10.3601C21.0267 10.2934 19.3867 8.60008 19.3867 6.52008C19.3867 4.40008 21.1067 2.66675 23.2401 2.66675C25.3601 2.66675 27.0934 4.38675 27.0934 6.52008C27.0801 8.60008 25.44 10.2934 23.3734 10.3601Z"
			      fill={color}/>
			<path opacity="0.4"
			      d="M27.72 19.6C26.2266 20.6 24.1333 20.9734 22.2 20.72C22.7066 19.6267 22.9733 18.4134 22.9866 17.1334C22.9866 15.8 22.6933 14.5334 22.1333 13.4267C24.1066 13.1601 26.2 13.5334 27.7066 14.5334C29.8133 15.92 29.8133 18.2 27.72 19.6Z"
			      fill={color}/>
			<path opacity="0.4"
			      d="M8.5867 10.3601C8.68003 10.3468 8.77337 10.3468 8.8667 10.3601C10.9334 10.2934 12.5734 8.60008 12.5734 6.52008C12.5734 4.40008 10.8534 2.66675 8.72003 2.66675C6.60003 2.66675 4.8667 4.38675 4.8667 6.52008C4.88003 8.60008 6.52003 10.2934 8.5867 10.3601Z"
			      fill={color}/>
			<path opacity="0.4"
			      d="M8.73349 17.1334C8.73349 18.4267 9.01349 19.6534 9.52015 20.7601C7.64015 20.9601 5.68016 20.5601 4.24016 19.6134C2.13349 18.2134 2.13349 15.9334 4.24016 14.5334C5.66682 13.5734 7.68016 13.1867 9.57349 13.4001C9.02682 14.5201 8.73349 15.7867 8.73349 17.1334Z"
			      fill={color}/>
			<path
				d="M16.1599 21.16C16.0532 21.1467 15.9332 21.1467 15.8132 21.16C13.3599 21.08 11.3999 19.0667 11.3999 16.5867C11.3999 14.0533 13.4399 12 15.9866 12C18.5199 12 20.5732 14.0533 20.5732 16.5867C20.5732 19.0667 18.6266 21.08 16.1599 21.16Z"
				fill={color}/>
			<path
				d="M11.8269 23.92C9.81356 25.2667 9.81356 27.48 11.8269 28.8134C14.1202 30.3467 17.8802 30.3467 20.1736 28.8134C22.1869 27.4667 22.1869 25.2534 20.1736 23.92C17.8936 22.3867 14.1336 22.3867 11.8269 23.92Z"
				fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1074_2148" x1="26.9289" y1="2.66675" x2="19.017" y2="3.06789"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
